import { AWSImage } from '@skop-app/lib-front'

import { AdaptedProduct } from '@/types'

type SmallProductCardProps = {
  product: Partial<AdaptedProduct>
}

export const SmallProductCard = ({ product }: SmallProductCardProps) => {
  const firstPicture = product.pictures?.[0] ?? ''
  const quantityLabel = product['quantity.number']?.label?.toString() ?? ''
  const reference = product['ref']

  return (
    <div className="m-0.5 grid grid-cols-3 gap-2 overflow-hidden rounded-md border border-border bg-white">
      <div className="col-span-1">
        <div className="h-full">
          <AWSImage
            src={firstPicture}
            alt={product.name?.label ?? ''}
            className="aspect-square aspect-1 w-full object-cover"
            thumbnail
          />
        </div>
      </div>
      <div className="col-span-2 flex flex-col justify-between pr-2">
        <div className="pt-1 text-sm">
          <h3 className="line-clamp-1 font-medium text-slate-500">
            {product.name?.label}
          </h3>
          {reference && (
            <p className="text-slate-300">{reference.label}</p>
          )}
          {product.condition && (
            <p className="text-slate-300">{product.condition?.label}</p>
          )}
          {product.provenance && (
            <p className="text-slate-300">{product.provenance?.label}</p>
          )}
          {product.brand && product.model && (
            <p className="text-slate-300">
              {product.brand?.label} {product.model?.label}
            </p>
          )}
        </div>

        <div className="flex items-center justify-between text-sm ">
          <div>
            <p className="text-slate-300">{quantityLabel}</p>
            <p>{product.price?.label}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
